import React, { useRef, useEffect } from 'react';
import { Container, Form, FormGroup, Input, ButtonGroup, Button } from 'reactstrap';
import { Save, PlayCircle, RefreshCw } from 'react-feather';
import EditorPlayer from './EditorPlayer';
import ArabicSpans from './ArabicSpans';
const Controls = (props) => {
  const { text, setText, selectedVoice, selectedLanguage, volume, speedValue, fileFormatValue } =
    props;

  const textAreaRef = useRef(null);

  const handleClearText = () => {
    setText('');
    textAreaRef.current.focus();
  };

  // if language changes, clear the text
  useEffect(() => {
    setText('');
  }, [selectedLanguage]);

  // keyboard shortcuts buttons for arabic spans
  const localToken = JSON.parse(localStorage.getItem('user'));
  const accessTokens = localToken.auth.login.data.access_token;

  const showArabicSpans = selectedLanguage?.toLowerCase().startsWith('ar');

  return (
    <div className="text-editor container-fluid p-1 shadow m-2">
      <h2 className="border-bottom text-primary">Text</h2>
      <Form className=" ">
        <FormGroup>
          <Input
            type="textarea"
            name="text"
            id="exampleText"
            placeholder={showArabicSpans ? 'أدخـل الـنـص هـنـا' : 'Enter Text Here'}
            rows="10"
            value={text}
            onChange={(e) => setText(e.target.value)}
            innerRef={textAreaRef}
            disabled={selectedVoice === ''}
            // if selectedLanguage is arabic, set text direction to rtl else set it to ltr
            style={{ direction: showArabicSpans ? 'rtl' : 'ltr' }}
          />
          {
            // if selectedLanguage is arabic, show the arabic spans buttons else show nothing
            showArabicSpans ? (
              <ArabicSpans textAreaRef={textAreaRef} setText={setText} text={text} />
            ) : (
              ''
            )
          }
        </FormGroup>
        <FormGroup className="d-flex justify-content-between border-bottom pb-1">
          <p>100 Words Remaining(Maximum Of 100)</p>
          <span
            className="d-inline-block"
            tabIndex="0"
            data-toggle="tooltip"
            title="reset text box">
            <RefreshCw className="refresh-btn text-primary" size={20} onClick={handleClearText} />
          </span>
        </FormGroup>
        <FormGroup className="d-flex  justify-content-between">
          <div>
            <h3 className="text-primary">Listen,Customize & Download Speech</h3>
            <p>
              Type or copy and paste text in the above textbox.
              <br />
              Press play to listen to your speech then press save..
              <br />
              Manage/Download saved audios from the History page.
            </p>
          </div>
          <div className="d-flex justify-content-end">
            <EditorPlayer
              selectedVoice={selectedVoice}
              text={text}
              accessTokens={accessTokens}
              setText={setText}
              volume={volume}
              speedValue={speedValue}
              fileFormatValue={fileFormatValue}
            />
          </div>
        </FormGroup>
      </Form>
    </div>
  );
};

export default Controls;
